import React, { useState } from 'react';
import { ethers } from 'ethers';
import { useContracts } from '../../hooks/useContract';
import { useNotify } from '../../context/NotificationContext';
import { ButtonSpinner } from '../common/Loader';
import { parseError } from '../../utils/errors';
import { PACKAGE_NAMES, NUM_PACKAGES } from '../../utils/constants';

export const VirtualUsers = () => {
  const { adminW } = useContracts();
  const notify = useNotify();

  const [regAddr, setRegAddr]   = useState('');
  const [regRef, setRegRef]     = useState('');

  const [vAddr, setVAddr]       = useState('');
  const [vRef, setVRef]         = useState('');
  const [vPkg, setVPkg]         = useState(0);

  const [lAddr, setLAddr]       = useState('');
  const [lRef, setLRef]         = useState('');
  const [lPkg, setLPkg]         = useState(0);

  const [busy, setBusy] = useState(null);

  const runTx = async (label, fn) => {
    setBusy(label);
    try {
      const tx = await fn();
      notify.info(`${label}: submitted`);
      await tx.wait();
      notify.success(`${label}: success`);
    } catch (e) {
      notify.error(parseError(e));
    } finally {
      setBusy(null);
    }
  };

  return (
    <div>
      <div className="card mb-24">
        <div className="section-title">Virtual Register (no funds required)</div>
        <div className="admin-form-grid">
          <div className="input-group">
            <label className="input-label">User Address</label>
            <input className="input" placeholder="0x..." value={regAddr} onChange={(e) => setRegAddr(e.target.value)} />
          </div>
          <div className="input-group">
            <label className="input-label">Referrer ID (0 = default)</label>
            <input className="input" type="number" value={regRef} onChange={(e) => setRegRef(e.target.value)} />
          </div>
        </div>
        <button
          className="btn btn-primary"
          disabled={busy === 'vreg' || !regAddr}
          onClick={() => runTx('vreg', () => adminW.virtualRegister(regAddr, regRef || 0))}
        >
          {busy === 'vreg' && <ButtonSpinner />}Virtual Register
        </button>
      </div>

      <div className="card mb-24">
        <div className="section-title">Virtual Investment (creates record, no USDC pull)</div>
        <div className="admin-form-grid">
          <div className="input-group">
            <label className="input-label">User Address</label>
            <input className="input" placeholder="0x..." value={vAddr} onChange={(e) => setVAddr(e.target.value)} />
          </div>
          <div className="input-group">
            <label className="input-label">Referrer ID</label>
            <input className="input" type="number" value={vRef} onChange={(e) => setVRef(e.target.value)} />
          </div>
          <div className="input-group">
            <label className="input-label">Package</label>
            <select className="select" value={vPkg} onChange={(e) => setVPkg(Number(e.target.value))}>
              {Array.from({ length: NUM_PACKAGES }).map((_, i) => (
                <option key={i} value={i}>{i} — {PACKAGE_NAMES[i]}</option>
              ))}
            </select>
          </div>
        </div>
        <button
          className="btn btn-primary"
          disabled={busy === 'vinv' || !vAddr}
          onClick={() => runTx('vinv', () => adminW.virtualInvestment(vAddr, vRef || 0, vPkg))}
        >
          {busy === 'vinv' && <ButtonSpinner />}Virtual Invest
        </button>
      </div>

      <div className="card">
        <div className="section-title">Leader Investment (record only, no ROI/income)</div>
        <div className="admin-form-grid">
          <div className="input-group">
            <label className="input-label">User Address</label>
            <input className="input" placeholder="0x..." value={lAddr} onChange={(e) => setLAddr(e.target.value)} />
          </div>
          <div className="input-group">
            <label className="input-label">Referrer ID</label>
            <input className="input" type="number" value={lRef} onChange={(e) => setLRef(e.target.value)} />
          </div>
          <div className="input-group">
            <label className="input-label">Package</label>
            <select className="select" value={lPkg} onChange={(e) => setLPkg(Number(e.target.value))}>
              {Array.from({ length: NUM_PACKAGES }).map((_, i) => (
                <option key={i} value={i}>{i} — {PACKAGE_NAMES[i]}</option>
              ))}
            </select>
          </div>
        </div>
        <button
          className="btn btn-gold"
          disabled={busy === 'lead' || !lAddr}
          onClick={() => runTx('lead', () => adminW.leaderInvestment(lAddr, lRef || 0, lPkg))}
        >
          {busy === 'lead' && <ButtonSpinner />}Leader Invest
        </button>
      </div>
    </div>
  );
};
